module.exports = __webpack_public_path__ + "static/media/clean_and_jerk-01.21d5f4ad.png";